import api from "./axios";
import type { Customer } from "../types/customer";
import { mapCustomersResponse } from "../types/customer";

export const getCustomersApi = async (): Promise<Customer[]> => {
  try {
    const response = await api.get<any>("/api/v1/customers");
    return mapCustomersResponse(response.data);
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

interface CreateCustomerData {
  name: string;
}

export const createCustomerApi = async (data: CreateCustomerData) => {
  try {
    const response = await api.post("/api/v1/customers", data);
    return response.data;
  } catch (error) {
    console.error("Error creating customer:", error);
    throw error;
  }
};

interface UpdateCustomerData {
  name: string;
}

export const updateCustomerApi = async (customerId: string, data: UpdateCustomerData) => {
  try {
    const response = await api.put(`/api/v1/customers/${customerId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating customer:", error);
    throw error;
  }
};
